import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWrapperService } from '../common/http-wrapper/http-wrapper.service';
import { NewsroomFilterModel } from '../../../../api/amplify/model/amplify-request.model';
import { StorySearchParams } from '../../../../api/story/model/story-search-Query-Params.model';
import { AmplifyStoryResultModel } from '../../../../api/amplify/model/amplify-unified.model';
import { UnifiedStoryResponseModel } from '../../../../api/story/model/story-response.model';

@Injectable()
export class NewsroomApiService {
    constructor(private httpService: HttpWrapperService ) { }

    public getNewroomStoryList(reqModel: NewsroomFilterModel, reqParams: StorySearchParams ): Observable<AmplifyStoryResultModel> {
        return this.httpService.newsroomPost<AmplifyStoryResultModel>(
            '/stories/search',
            reqModel,
            reqParams
        );
    }

    public getNewroomStory(storyId: number): Observable<UnifiedStoryResponseModel>  {
        return this.httpService.newsroomGet<UnifiedStoryResponseModel>(`/stories/${storyId}` , null);
    }

    public getImageData(imageId: string): Observable<Blob> {
        return this.httpService.newsroomGetImage(`/images/${imageId}`);
    }
}
